/**
 * Wiki markdown export filename: owner-repo-wiki[-vN].md
 *
 * Shared by the export route (which always knows the version) and the client
 * fallback used when the response carries no Content-Disposition, so the two
 * cannot drift.
 */

/**
 * Sanitizes a string for safe use in filenames.
 * Replaces non-alphanumeric characters with hyphens and collapses multiple hyphens.
 */
function sanitizeFilenameSegment(value: string): string {
  // Replace non-word chars (except . and -) with hyphens, collapse consecutive hyphens
  const cleaned = value.replace(/[^\w.-]+/g, '-').replace(/-+/g, '-');
  // Remove leading/trailing hyphens, fallback to 'wiki' if empty
  return cleaned.replace(/^-|-$/g, '') || 'wiki';
}

/** Builds a sanitized filename for wiki export: owner-repo-wiki[-vN].md */
export function buildExportFilename(owner: string, repo: string, version?: number | null): string {
  const safeOwner = sanitizeFilenameSegment(owner);
  const safeRepo = sanitizeFilenameSegment(repo);
  const versionSuffix = version !== null && version !== undefined ? `-v${version}` : '';
  return `${safeOwner}-${safeRepo}-wiki${versionSuffix}.md`;
}
